// Card Product functionality - centralized
window.CardProduct = {
  // Initialize all card products on the page
  initializeAll: function() {
    document.querySelectorAll('.card-product').forEach((card) => {
      this.initialize(card);
    });
  },

  // Initialize a specific card product
  initialize: function(card) {
    // Skip if already initialized
    if (card.dataset.cardProductInitialized === 'true') {
      return;
    }
    
    const slides = card.querySelectorAll('.card-product__media-slide');
    const leftChevron = card.querySelector('.card-product__chevron--left button');
    const rightChevron = card.querySelector('.card-product__chevron--right button');
    const swatches = card.querySelectorAll('.card-product__swatch');
    
    let currentSlide = 0;

    // Function to show specific slide
    const showSlide = (index) => {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      currentSlide = index;
      
      // Update corresponding swatch selection
      const activeSlide = slides[index];
      const mediaId = activeSlide ? activeSlide.dataset.mediaId : null;
      if (mediaId) {
        swatches.forEach(swatch => {
          swatch.classList.toggle('is-selected', swatch.dataset.mediaId === mediaId);
        });
      }
    };

    // Chevron controls
    if (leftChevron && rightChevron && slides.length > 1) {
      leftChevron.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const newIndex = (currentSlide - 1 + slides.length) % slides.length;
        showSlide(newIndex);
      });

      rightChevron.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const newIndex = (currentSlide + 1) % slides.length;
        showSlide(newIndex);
      });
    }

    // Swatch controls
    swatches.forEach((swatch) => {
      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const mediaId = swatch.dataset.mediaId;
        if (mediaId) {
          const targetSlide = card.querySelector(`.card-product__media-slide[data-media-id="${mediaId}"]`);
          if (targetSlide) {
            const slideIndex = Array.from(slides).indexOf(targetSlide);
            showSlide(slideIndex);
          }
        }
        
        // Update swatch selection
        swatches.forEach(s => s.classList.remove('is-selected'));
        swatch.classList.add('is-selected');
      });
    });
    
    // Mark as initialized
    card.dataset.cardProductInitialized = 'true';
  }
};

// Global utility function for easy initialization from any section
window.initializeCardProducts = function(container) {
  if (!container) {
    // If no container specified, initialize all on page
    window.CardProduct.initializeAll();
  } else {
    // Initialize cards within specific container
    const cards = container.querySelectorAll('.card-product');
    cards.forEach(card => {
      window.CardProduct.initialize(card);
    });
  }
};

document.addEventListener('DOMContentLoaded', function () {
  // Initialize all existing card products
  window.CardProduct.initializeAll();

  // Main Product functionality (existing code)
  const updateAddToCartState = (enabled) => {
    const addBtn = document.querySelector('.main-product__add-button');
    if (addBtn) {
      addBtn.disabled = !enabled;
      addBtn.classList.toggle('is-disabled', !enabled);
    }
  };

  const variantInput = document.querySelector('.main-product__variant-id');
  const swatches = document.querySelectorAll('.main-product__swatch');
  const sizes = document.querySelectorAll('.main-product__size-button');
  const product = window.product || Shopify.product;

  const getSelectedColor = () => {
    const selected = document.querySelector('.main-product__swatch.is-selected');
    return selected ? selected.getAttribute('title') : null;
  };

  const getSelectedSize = () => {
    const selected = document.querySelector('.main-product__size-button.is-selected');
    return selected ? selected.dataset.option2 : null;
  };

  const selectVariantByOptions = () => {
    const color = getSelectedColor();
    const size = getSelectedSize();

    if (!color || !size) {
      updateAddToCartState(false);
      return;
    }

    const match = product.variants.find(v =>
      v.option1.toLowerCase() === color.toLowerCase() &&
      v.option2 === size
    );

    if (match) {
      if (variantInput) {
        variantInput.value = match.id;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url.toString());

      updateAddToCartState(match.available);
    } else {
      updateAddToCartState(false);
    }
  };

  const updateGallerySwatchSelection = (mediaId) => {
    const swatches = document.querySelectorAll('.product-gallery__swatch');
    swatches.forEach(s => {
      s.classList.toggle('is-selected', s.dataset.mediaId === mediaId);
    });
  };

  const showSlide = (targetIndex) => {
    const slides = document.querySelectorAll('.product-gallery__slide');
    slides.forEach((slide, i) => {
      const isActive = i === targetIndex;
      slide.classList.toggle('is-active', isActive);
      if (isActive) {
        updateGallerySwatchSelection(slide.dataset.mediaId);
      }
    });
  };

  // Chevron controls
  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const slides = gallery.querySelectorAll('.product-gallery__slide');
    const left = gallery.querySelector('.product-gallery__chevron--left');
    const right = gallery.querySelector('.product-gallery__chevron--right');

    let current = 0;

    if (left && right) {
      left.addEventListener('click', () => {
        current = (current - 1 + slides.length) % slides.length;
        showSlide(current);
      });
      right.addEventListener('click', () => {
        current = (current + 1) % slides.length;
        showSlide(current);
      });
    }
  });

  // Swatch click
  swatches.forEach((swatch, index) => {
    swatch.addEventListener('click', () => {
      swatches.forEach(s => s.classList.remove('is-selected'));
      swatch.classList.add('is-selected');
      const mediaId = swatch.dataset.mediaId;

      if (mediaId) {
        const gallerySlide = document.querySelector(`.product-gallery__slide[data-media-id="${mediaId}"]`);
        document.querySelectorAll('.product-gallery__slide').forEach(slide => slide.classList.remove('is-active'));
        if (gallerySlide) gallerySlide.classList.add('is-active');
        updateGallerySwatchSelection(mediaId);
      }

      selectVariantByOptions();
    });
  });

  // Size click
  sizes.forEach(button => {
    button.addEventListener('click', () => {
      sizes.forEach(b => b.classList.remove('is-selected'));
      button.classList.add('is-selected');
      selectVariantByOptions();
    });
  });

  // Load from URL or select defaults
  const params = new URLSearchParams(window.location.search);
  const variantFromUrl = params.get('variant');

  if (variantFromUrl) {
    const matchedVariant = product.variants.find(v => v.id.toString() === variantFromUrl);
    if (matchedVariant) {
      const color = matchedVariant.option1;
      const size = matchedVariant.option2;

      const swatchToSelect = Array.from(swatches).find(s => s.getAttribute('title') === color);
      const sizeToSelect = Array.from(sizes).find(s => s.dataset.option2 === size);

      if (swatchToSelect) swatchToSelect.click();
      if (sizeToSelect) sizeToSelect.click();
    }
  } else {
    if (swatches.length > 0) swatches[0].click();
    if (sizes.length > 0) sizes[0].click();
  }
});